export const buildDocumentList = (data: { id: string; unverifiedDocuments: number }[]): string[] => {
    return data.filter((lr) => lr.unverifiedDocuments > 0).map((lr) => lr.id);
};
